import React, { useEffect } from "react";

import FeaturedCollection from "../components/FeaturedCollection";
import GamingGearBanner from "../components/GamingGearBanner";
import HomeBanner from "../components/HomeBanner";
import OurOffers from "../components/OurOffers";
import ServiceHome from "../components/ServiceHome";

function HomePage() {
  useEffect(() => {
    document.title = "Buzz Mobile - Премиум мобилара";
  }, []);

  return (
    <div>
      <HomeBanner />
      <OurOffers />
      <FeaturedCollection
        sectionId="featured-phones"
        eyebrow="Избрано за вас"
        gear="Најдобра понуда"
        description="Топ модели на телефони со конкурентни цени и гаранција"
        results={8}
        featured="/products?category=telefoni&promotion=true"
      />
      <GamingGearBanner />
      <FeaturedCollection
        eyebrow=""
        gear=""
        description=""
        results={8}
        featured="/accessories?category=kgalanterija&promotion=true"
      />
      <ServiceHome />
    </div>
  );
}

export default HomePage;
